import { ISearchQuery, SearchRepository } from '../repositories/SearchRepository';

export class SearchLoadedUseCase {
    private searchRepository: SearchRepository;

    constructor(searchRepository: SearchRepository) {
        this.searchRepository = searchRepository;
    }

    public execute = async (searchQuery: ISearchQuery) => {
        try {
            await this.searchRepository.getSearchResults(searchQuery);
        } catch (error) {
            console.error(error);
        }
    };
}
